import { render, staticRenderFns } from "./PollsList.vue?vue&type=template&id=1cd24dd6&"
import script from "./PollsList.vue?vue&type=script&lang=js&"
export * from "./PollsList.vue?vue&type=script&lang=js&"
import style0 from "./PollsList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PollsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports